import { render, staticRenderFns } from "./forgot-password-form.vue?vue&type=template&id=5a8a2148&scoped=true"
import script from "./forgot-password-form.vue?vue&type=script&lang=js"
export * from "./forgot-password-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a2148",
  null
  
)

export default component.exports